import { APPOINTMENTS } from '_constants';
import get from 'lodash/get';
import { LOGIN } from '../constants/login.constants';
import { INITIAL_APP_STATE } from '../constants/common.constants';

export const appointments = (state = {}, action = {}) => {
  let newState = { ...state };
  switch (action.type) {
    case APPOINTMENTS.FETCH_APPOINTMENTS: {
      let appointmentList = action.value;
      appointmentList = appointmentList.filter(value => {
        const { eventStatus = {} } = value;
        return ((eventStatus.name !== 'Completed') && (eventStatus.name !== 'Cancelled'));
      });
      newState.appointments = appointmentList;
    }
      break;

    case APPOINTMENTS.FETCH_MONTH_APPOINTENTS:
      newState = { ...state, monthAppointments: get(action, 'value.monthAppointments', []), activeDate: get(action, 'value.activeDate', null), isMonthApptLoading: false };
      break;

    case APPOINTMENTS.APPOINTMENT_SWITCH_VIEW:
      newState.showMonthView = action.value;
      break;
    case APPOINTMENTS.FETCH_DISPOSITIONS:
      if (!newState.dispositions) {
        newState.dispositions = {};
      }
      newState.dispositions[action.id] = action.value;
      break;
    case APPOINTMENTS.ACTIVE_DATE_CHANGED:
      newState.activeDate = action.value;
      break;

    case APPOINTMENTS.TOGGLE_VIEW:
      newState.isDateView = action.isDateView !== false;
      break;
    case APPOINTMENTS.UPDATE_CALENDAR:
      newState.calendar = action.calendar;
      break;
    case APPOINTMENTS.STORE_ALL_APPOINTMENTS:
      newState.allAppointments = action.value;
      break;
    case LOGIN.LOGOUT:
      newState = INITIAL_APP_STATE.appointments;
      break;
    default:
      break;
  }
  return newState;
};
